import React from 'react';
import clsx from 'clsx';

import './index.scss';
import logo from 'assets/caregiver-jobma.png';

import PcProgress from 'components/molecules/PcProgress';
import PcNotice from 'components/molecules/PcNotice';
import { PROGRESS_LIST,NAVI_NOTICE_MAP } from 'utils/constant';

const getStatus = (idx, nowStep) => {
  if(idx === nowStep) return 'doing';
  if(idx > nowStep) return 'todo';
  return 'done';
};

const IsDispNotice = (step) => {
  let result = false;
  if(step === '0'){
    result = true;
  }
  return result;
};

const PcSideArea = ({
  step,
  selects = [],
  isOver768 = false,
  showProgress = true,
  lpMode,
}) => (
  <div className={clsx('PcSideArea', { isOver768 })}>
    {!lpMode && (
      <img className="logoJobma" src={logo} alt="logo" />
    )}  
    <div className="wrapper">
      <div className="progress">
        {showProgress && PROGRESS_LIST.map((progress, idx) => {
          const { pStep, pTitle } = progress;
          const status = getStatus(idx, Number(step));
          return (
            <PcProgress
              key={pStep}
              status={status}
              step={pStep}
              title={pTitle}
              hasBar={status !== 'todo' && idx !== 0}
              selects={selects[pStep]}
            />
          );
        })}
        {IsDispNotice(step) && (
          <div className="noticearea">
            <PcNotice
              title={NAVI_NOTICE_MAP.title}
              notice={NAVI_NOTICE_MAP.notice}
            />
          </div>
        )}
      </div>
    </div>
  </div>
);

export default PcSideArea;
